import { withStyles } from '@material-ui/core';

import GridSection from './component';
import styles from './styles';

export default withStyles(styles)(GridSection);
